import { Controller } from "@hotwired/stimulus"
import * as toastr from 'toastr'

// Connects to data-controller="validation-matricula"
export default class extends Controller {
  static targets = [ "form", "matriculaInput", "nombreInput", "tabs" ]
  static values = {
    id: String,
    coordinacion: { type: Boolean, default: false },
    userMatricula: { type: String, default: '' }
  }

  connect() {
    this.isSubmitting = false;
    this.boundPreventFormSubmitOnEnter = this.preventFormSubmitOnEnter.bind(this);
    this.boundHandleModalKeydown = this.handleModalKeydown.bind(this);
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);

    this.element.addEventListener('keydown', this.boundPreventFormSubmitOnEnter);
    this.element.addEventListener('keydown', this.boundHandleModalKeydown);

    document.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd);

    try {
      if (this.hasMatriculaInputTarget && this.matriculaInputTarget) {
        this.matriculaInputTarget.addEventListener('input', () => {
          const hidden = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]');
          if (hidden) hidden.value = '';
        });
      }
    } catch (e) {}
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.boundPreventFormSubmitOnEnter);
    this.element.removeEventListener('keydown', this.boundHandleModalKeydown);
    document.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd);
  }

  handleSubmitEnd(event) {
    if (event.target.id === this.idValue) {
      this.isSubmitting = false;

      setTimeout(() => {
        this.toggleSubmittingState(false);
      }, 100);
    }
  }

  preventFormSubmitOnEnter(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const form = document.getElementById(this.idValue);

      const isInModal = target.closest('#matriculaValidacionModal');

      if (!isInModal && form.contains(target)) {
        const isTrixEditor = target.tagName === 'TRIX-EDITOR' || target.closest('trix-editor');
        if (isTrixEditor) {
          return;
        }

        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          event.preventDefault();
          return false;
        }
      }
    }
  }

  handleModalKeydown(event) {
    if (event.key === 'Enter') {
      const target = event.target;
      const isInModal = target.closest('#matriculaValidacionModal');

      if (isInModal && this.hasMatriculaInputTarget) {
        event.preventDefault();

        const matriculaValue = this.matriculaInputTarget.value;

        if (matriculaValue) {
          this.submitForm();
        } else {
          this.matriculaInputTarget.focus();
        }
      }
    }
  }

  openModal(e) {
    e.preventDefault();
    this.originalSubmitButton = e.currentTarget;
    if (this.isSubmitting) {
      return;
    }

    if (this.originalSubmitButton.classList.contains("disabled")) {
      return;
    }

    $('#matriculaValidacionModal').modal('show');
  }

  submitForm() {
    if (this.isSubmitting) {
      return;
    }

    const matriculaTexto = this.hasMatriculaInputTarget ? this.matriculaInputTarget.value.trim() : ''
    const hiddenField = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]')
    const matriculaSeleccionada = hiddenField ? (hiddenField.value || '').toString().trim() : ''
    const userMatricula = this.userMatriculaValue.toString().trim()

    if (matriculaTexto === '' || matriculaSeleccionada === '') {
      alert('Debes seleccionar un profesional del buscador. Escribe y elige una opción de la lista desplegable.');
      return
    }

    if (!this.coordinacionValue) {
      if (userMatricula === '') {
        alert('Tu usuario no tiene un profesional asociado. No puedes validar esta acción.');
        return
      }

      if (matriculaSeleccionada !== userMatricula) {
        alert('Solo puedes registrar una evolución con tu propia matrícula profesional.');
        return
      }
    }

    const form = document.getElementById(this.idValue)

    if (!form.checkValidity()) {
      const firstInvalidField = form.querySelector(':invalid')
      if (firstInvalidField) {
        firstInvalidField.reportValidity()
        firstInvalidField.focus()
      }

      toastr.options.closeButton = true
      toastr.options.closeDuration = 500
      toastr.error('Hay campos obligatorios sin completar o con formato invalido. Revisa el formulario e intenta nuevamente.')
      return
    }

    this.isSubmitting = true;
    this.toggleSubmittingState(true);
    form.requestSubmit();
    $('#matriculaValidacionModal').modal('hide');
  }

  getActiveTabName() {
    if (!this.hasTabsTarget) return null

    const activeTab = this.tabsTarget.querySelector(".nav-link.active")
    if (activeTab) {
      return activeTab.textContent.trim()
    }
    return null
  }

  closeModal() {
    $('#matriculaValidacionModal').modal('hide');
  }

  toggleSubmittingState(disabled) {
    if (this.originalSubmitButton) {
      this.originalSubmitButton.disabled = disabled;
      this.originalSubmitButton.classList.toggle('disabled', disabled);
    }

    const modalSubmitButton = document.querySelector('#matriculaValidacionModal [data-action="validation-matricula#submitForm"]');
    if (modalSubmitButton) {
      modalSubmitButton.classList.toggle('disabled', disabled);
      modalSubmitButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      modalSubmitButton.style.pointerEvents = disabled ? 'none' : '';
    }
  }
}
